import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Contact from "./pages/Contact";
import { CartToast }     from "./components/CartToast";
import OrderSuccess      from "./pages/OrderSuccess";
import AdminDashboard    from "./pages/AdminDashboard";
import TopBar            from "./components/TopBar";
import Navbar            from "./components/Navbar";
// import BrandIntro        from "./components/BrandIntro";
import Home   from "./pages/Home";
import CategoryProducts from "./pages/CategoryProducts";
// import ShopByCategory from "./pages/ShopByCategory";
// import CategoryPage from "./pages/CategoryPage"; // replaced by CategoryProducts (database categories)

// inside your <Routes>, alongside your existing routes:

import ProductList       from "./components/ProductList";
import FeaturesBar       from "./components/FeaturesBar";
import Footer            from "./components/Footer";
// import ChatBotFAQ        from "./components/ChatBotFAQ";
import EmailVerify       from "./pages/EmailVerify";
import ForgotPassword    from "./pages/ForgotPassword";
import Wishlist          from "./pages/Wishlist";
import Cart              from "./pages/Cart";
import ProductDetails    from "./pages/ProductDetails";
import Checkout          from "./pages/Checkout";
import AddProduct        from "./pages/AddProduct";
import Payment           from "./pages/Payment";
import MyOrders          from "./pages/MyOrders";
import BrandIntro from "./components/BrandIntro";

const HIDE_LAYOUT_ON = ["/login", "/forgot-password", "/admin"];

function App() {
  const location   = useLocation();
  const hideLayout = HIDE_LAYOUT_ON.includes(location.pathname);

  const [columns]  = useState(5);
  const [sortType] = useState("best");
  const [filters]  = useState({ price:[], fabric:[], color:[], type:[] });

  // Wishlist persisted to localStorage
  const [wishlist, setWishlistRaw] = useState(() => {
    try { return JSON.parse(localStorage.getItem("wishlist")) || []; }
    catch { return []; }
  });
  const setWishlist = (val) => {
    const next = typeof val === "function" ? val(wishlist) : val;
    setWishlistRaw(next);
    localStorage.setItem("wishlist", JSON.stringify(next));
  };

  // Cart persisted to localStorage
  const [cartItems, setCartItemsRaw] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cartItems")) || []; }
    catch { return []; }
  });
  const setCartItems = (val) => {
    const next = typeof val === "function" ? val(cartItems) : val;
    setCartItemsRaw(next);
    localStorage.setItem("cartItems", JSON.stringify(next));
  };

  const cartCount = cartItems.length;
  const wishCount = wishlist.length;

  // Check if user is logged in (Google or guest)
  const isLoggedIn = () => {
    const role  = localStorage.getItem("userRole");
    const email = localStorage.getItem("userEmail");
    return (role === "user" && !!email) || role === "guest";
  };

  // Logout — clears all auth data
  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userName");
    localStorage.removeItem("userPhoto");
    localStorage.removeItem("userRole");
    localStorage.removeItem("authToken");
  };

  return (
    <>
      {!hideLayout && <TopBar />}
      {!hideLayout && (
        <Navbar
          cartItems={cartItems}
          wishlist={wishlist}
          onLogout={handleLogout}
        />
      )}

      <Routes>

        {/* ROOT — go straight to home, no login wall */}
        <Route path="/"
          element={<Navigate to="/home" replace />}
        />

        {/* LOGIN — only if user navigates here directly */}
        {/* Normal flow: login modal appears inside Cart */}
        <Route path="/login"
          element={<EmailVerify />}
        />

        {/* FORGOT PASSWORD */}
        <Route path="/forgot-password"
          element={<ForgotPassword />}
        />

        {/* ADMIN — standalone page, no layout */}
        <Route path="/admin"
          element={<AdminDashboard />}
        />
<Route
  path="/contact"
  element={<Contact />}
/>
        {/* HOME — public, no login needed */}
        <Route path="/home" element={
          <>

            <BrandIntro/>
            <Home />
            <ProductList
              columns={columns}
              sortType={sortType}
              filters={filters}
              wishlist={wishlist}
              setWishlist={setWishlist}
              cartItems={cartItems}
              setCartItems={setCartItems}
            />
            <FeaturesBar />
          </>
        } />
        <Route path="/category/:slug" element={
          <CategoryProducts
            wishlist={wishlist}
            onToggleWishlist={(p) =>
              setWishlist((prev) =>
                prev.some((w) => (w._id || w.id) === p._id)
                  ? prev.filter((w) => (w._id || w.id) !== p._id)
                  : [...prev, p]
              )
            }
          />
        } />

        {/* PRODUCT DETAIL — public */}
        <Route path="/product/:id" element={
          <ProductDetails
            wishlist={wishlist}
            setWishlist={setWishlist}
            cartItems={cartItems}
            setCartItems={setCartItems}
          />
        } />

        {/* WISHLIST — public */}
        <Route path="/wishlist" element={
          <Wishlist
            wishlist={wishlist}
            setWishlist={setWishlist}
            cartItems={cartItems}
            setCartItems={setCartItems}
          />
        } />

        {/* CART — public, login modal appears here on checkout click */}
        <Route path="/cart" element={
          <Cart
            cartItems={cartItems}
            setCartItems={setCartItems}
          />
        } />

        {/* CHECKOUT — login required, else back to cart */}
        <Route path="/checkout" element={
          isLoggedIn()
            ? <Checkout cartItems={cartItems} setCartItems={setCartItems} />
            : <Navigate to="/cart" replace />
        } />

        {/* PAYMENT — login required */}
        <Route path="/payment" element={
          isLoggedIn()
            ? <Payment cartItems={cartItems} setCartItems={setCartItems} />
            : <Navigate to="/cart" replace />
        } />

        {/* ORDER SUCCESS — login required */}
        <Route path="/order-success" element={
          isLoggedIn()
            ? <OrderSuccess />
            : <Navigate to="/cart" replace />
        } />

        {/* MY ORDERS — login required */}
        <Route path="/my-orders" element={
          isLoggedIn()
            ? <MyOrders />
            : <Navigate to="/cart" replace />
        } />
        {/* old /category/:categoryName route removed — /category/:slug above handles every category */}

        {/* ADD PRODUCT — login required */}
        <Route path="/add-product" element={
          isLoggedIn()
            ? <AddProduct />
            : <Navigate to="/cart" replace />
        } />

        {/* CATCH ALL — redirect to home */}
        <Route path="*"
          element={<Navigate to="/home" replace />}
        />

      </Routes>

      {/* CartToast renders globally outside Routes */}
      <CartToast />

      {/* {!hideLayout && <ChatBotFAQ />} */}
      {!hideLayout && <Footer />}
    </>
  );
}

export default App;